import { Opcion } from '../../../models/catalogo.type'
import { Paginado } from '../../../models/paginado.type'

export interface Tarea {
  /**
   * Identificador de tarea.
   * Nota: aparece como `any` en algunos flujos legacy (por compatibilidad con tablas/UI).
   */
  idTarea?: string | any
  idSitio?: string
  nombreSitio?: string
  idAutorizacion?: string
  descAutorizacion?: string
  nombreAutorizacion?: string
  idCondicionante?: string
  nombreCondicionante?: string
  titulo: string
  idUsuarioAsignado?: string
  nombreUsuarioAsignado?: string
  fechaInicio: string
  fechaTermino: string
  descripcion: string
  /** Estatus puede venir como string (backend) u opcion (UI). */
  estatus?: string | any | Opcion
  descEstatus?: string | null
  /** Recordatorios pueden venir tipados o como arreglo crudo (legacy). */
  recordatorios?: any[] | Recordatorio[]
  comentarioCierre?: string
}

export interface Recordatorio {
  idRecordatorio: string
  cantidad: number
  unidad: string
  descUnidad: string
  tipo: string
  descTipo: string
  /** Fecha base sobre la cual se calcula el recordatorio (backend). */
  fechaReferencia: string
  /** Fecha objetivo del recordatorio (si es personalizado o calculado). */
  fechaRecordatorio: string
}
export interface PaginadoTareas extends Paginado {
  tareas: Tarea[]
}

export interface TareasReduxState {
  tareas: Tarea[]
}

export const TareaVacia: TareasReduxState = {
  tareas: [],
}
